<script setup lang="ts">
import { Link } from '@inertiajs/vue3';
import { type LinkDescription } from 'types';
import { route } from '../../composables/routes';

defineProps<{
    description: LinkDescription
}>();
</script>

<template>
    <Link
        :href="route(description.route.name, description.route.parameters)"
        class="text-rose-500 hover:underline">
        {{ description.label }}
    </Link>
</template>